import React, { ComponentPropsWithoutRef } from 'react';
import { OmitStrict, withCoreUIType } from '@tanium/coreui-utils';
import { Breadcrumb } from '@tanium/react-breadcrumbs';
import { PAGE_HEADER_COREUITYPE, PageHeaderBase } from '@tanium/react-page-base';
import { useWorkbenchDetails } from '@tanium/react-workbench-details-context';

interface BreadcrumbItem {
  href: string;
  label: string;
}

type PageHeaderBaseProps = ComponentPropsWithoutRef<typeof PageHeaderBase>;

export interface Props extends OmitStrict<PageHeaderBaseProps, 'breadcrumbs'> {
  /**
   * @deprecated Use `Workbench` component `breadcrumbs` instead.
   */
  breadcrumbs?: false;
}

/**
 * PageHeader component.
 */
const PageHeaderInner = ({ breadcrumbs: breadcrumbsProp = false, ...props }: Props) => {
  const { productName, homeUrl } = useWorkbenchDetails();

  const formatPojoBreadcrumbs = (pojoBreadcrumbs: BreadcrumbItem[]) => {
    const initialBreadcrumbs: BreadcrumbItem[] = [
      { href: '/', label: 'Tanium' },
      { href: homeUrl, label: productName },
    ];

    return initialBreadcrumbs.concat(pojoBreadcrumbs).map(({ href, label }) => (
      <Breadcrumb key={`${label}|${href}`} href={href}>
        {label}
      </Breadcrumb>
    ));
  };

  const getBreadcrumbs = () => {
    if (breadcrumbsProp === false) {
      return undefined;
    }

    return formatPojoBreadcrumbs(breadcrumbsProp);
  };

  const breadcrumbs = getBreadcrumbs();

  return <PageHeaderBase {...props} breadcrumbs={breadcrumbs} />;
};

export const PageHeader = withCoreUIType(PAGE_HEADER_COREUITYPE)(PageHeaderInner);
